import {
  Component,
  inject,
  input,
  InputSignal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ModalController, IonIcon, IonButton } from '@ionic/angular/standalone';
import { Hint } from '../../../models/hint.model';
import { addIcons } from 'ionicons';
import { bulb, close } from 'ionicons/icons';
import { DisplayMathPipe } from '@lyceo/shared/question-display/feature-main';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-clue-content',
  templateUrl: './clue-content.component.html',
  styleUrls: ['./clue-content.component.scss'],
  imports: [IonIcon, IonButton, DisplayMathPipe],
})
export class ClueContentComponent {
  private readonly modalController: ModalController = inject(ModalController);

  /**
   * The hint to show in the modal.
   */
  public readonly hint: InputSignal<Hint> = input.required<Hint>();

  /**
   * The index (zero-based) of the hint within the question.
   */
  public readonly index: InputSignal<number> = input.required<number>();

  constructor() {
    addIcons({ bulb, close });
  }

  /**
   * Dismiss the modal.
   */
  public async dismiss(): Promise<void> {
    await this.modalController.dismiss();
  }
}
